import { Alert, Link } from '@mui/material'

const BannerAlert: React.FC = (props) => {
  return (
    <Alert color="warning">
      Testa en ny version av Tentamera:{' '}
      <Link href="https://tentamera.netlify.app/">tentamera.netlify.app</Link>
    </Alert>
  )
}

export default BannerAlert
